module.exports = __webpack_public_path__ + "img/ch23_06_补全法则.4842dce0.jpg";